import {ConfigurationTemplateDto} from "@hec/api-dtos";

export interface DormerState {
  configurationTemplates: ConfigurationTemplateDto[];
}
